import { apiSlice } from '@src/services/api/apiSlice';
import { DeleteRoleParams } from '@src/services/role/deleteRole/roleDeleteApiSliceTypes';

const deleteRoleApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        deleteRole: builder.mutation({
            query: ({ id }: DeleteRoleParams) => ({
                url: `/roles/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, _, { id }) =>
                result
                    ? [
                          { type: 'roles', id },
                          { type: 'roles', id: 'LIST' },
                      ]
                    : [],
        }),
    }),
    overrideExisting: true,
});

export const { useDeleteRoleMutation } = deleteRoleApiSlice;
